import React from 'react';
import PropTypes from 'prop-types';
import {Icons} from '@learningblocks/exp-constants';

const {StartSolid: CaretRight} = Icons;

export function IconDown(props) {
  const iconStyle = {...props.style, transform: 'rotate(90deg)'};
  return (
    <CaretRight
      onClick={props.onClick}
      style={iconStyle}
      className={props.className}
      aria-label={'Select to move the band down and decrease the BP'}
    />
  );
}

export function IconUp(props) {
  const iconStyle = {...props.style, transform: 'rotate(-90deg)'};
  return (
    <CaretRight
      onClick={props.onClick}
      style={iconStyle}
      className={props.className}
      aria-label={'Select to move the band up and increase the BP'}
    />
  );
}

IconDown.propTypes = {
  /**
   * className to set on Icon
   */
  className: PropTypes.string,
  /**
   * Function to invoke on click
   */
  onClick: PropTypes.func,
  /**
   * Style to set on icon
   */
  style: PropTypes.object,
};

IconUp.propTypes = IconDown.propTypes;

IconUp.defaultProps = IconDown.defaultProps = {
  className: '',
  style: {},
};
